import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSpinner = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      d="M10.5417 0.458333C10.5417 0.205203 10.747 0 11.0001 0C11.2532 0 11.4584 0.205203 11.4584 0.458333V5.04167C11.4584 5.2948 11.2532 5.5 11.0001 5.5C10.747 5.5 10.5417 5.2948 10.5417 5.04167V0.458333Z"
      fill="currentColor"
    />
    <path
      d="M0.458333 12C0.205202 12 -2.34843e-08 11.4627 -5.24537e-08 10.8C-8.1423e-08 10.1373 0.205203 9.6 0.458333 9.6L5.04167 9.6C5.2948 9.6 5.5 10.1373 5.5 10.8C5.5 11.4627 5.2948 12 5.04167 12L0.458333 12Z"
      fill="currentColor"
    />
    <path
      d="M6.58402 20.6231C6.45746 20.8423 5.97212 20.799 5.5 20.5265C5.02787 20.2539 4.74774 19.8552 4.87431 19.636L7.16597 15.6667C7.29254 15.4475 7.77787 15.4907 8.25 15.7633C8.72212 16.0359 9.00226 16.4346 8.87569 16.6538L6.58402 20.6231Z"
      fill="currentColor"
    />
    <path
      d="M17.0349 19.6883C17.1614 19.9075 16.922 20.2827 16.5 20.5263C16.078 20.77 15.6333 20.7897 15.5068 20.5705L13.2151 16.6012C13.0885 16.382 13.328 16.0068 13.75 15.7632C14.172 15.5196 14.6166 15.4998 14.7432 15.719L17.0349 19.6883Z"
      fill="currentColor"
    />
    <path
      d="M20.5711 15.5057C20.7903 15.6323 20.7703 16.0774 20.5263 16.4999C20.2824 16.9224 19.9069 17.1623 19.6877 17.0358L15.7184 14.7441C15.4992 14.6175 15.5192 14.1724 15.7632 13.7499C16.0071 13.3274 16.3826 13.0875 16.6018 13.214L20.5711 15.5057Z"
      fill="currentColor"
    />
    <path
      d="M19.9002 5.33219C20.1194 5.20563 20.3997 5.28074 20.5263 5.49996C20.6529 5.71917 20.5777 5.99949 20.3585 6.12605L16.3892 8.41772C16.17 8.54428 15.8897 8.46917 15.7631 8.24996C15.6366 8.03074 15.7117 7.75043 15.9309 7.62386L19.9002 5.33219Z"
      fill="currentColor"
    />
    <path
      d="M12 21.5833C12 21.8135 11.5523 22 11 22C10.4477 22 10 21.8135 10 21.5833L10 17.4167C10 17.1865 10.4477 17 11 17C11.5523 17 12 17.1865 12 17.4167L12 21.5833Z"
      fill="currentColor"
    />
    <path
      d="M21.5417 10.5415C21.7948 10.5415 22 10.7467 22 10.9998C22 11.253 21.7948 11.4582 21.5417 11.4582L16.9583 11.4582C16.7052 11.4582 16.5 11.253 16.5 10.9998C16.5 10.7467 16.7052 10.5415 16.9583 10.5415L21.5417 10.5415Z"
      fill="currentColor"
    />
    <path
      d="M15.8739 1.64156C16.0004 1.42234 16.2807 1.34723 16.5 1.4738C16.7192 1.60036 16.7943 1.88067 16.6677 2.09989L14.3761 6.06917C14.2495 6.28839 13.9692 6.3635 13.75 6.23694C13.5307 6.11037 13.4556 5.83006 13.5822 5.61084L15.8739 1.64156Z"
      fill="currentColor"
    />
    <path
      d="M5.33219 2.09981C5.20563 1.88059 5.28074 1.60028 5.49996 1.47371C5.71917 1.34715 5.99949 1.42226 6.12605 1.64148L8.41772 5.61076C8.54428 5.82998 8.46917 6.11029 8.24996 6.23685C8.03074 6.36342 7.75043 6.28831 7.62386 6.06909L5.33219 2.09981Z"
      fill="currentColor"
    />
    <path
      d="M1.64143 6.12614C1.42222 5.99957 1.34711 5.71926 1.47367 5.50004C1.60024 5.28083 1.88055 5.20572 2.09977 5.33228L6.06905 7.62395C6.28827 7.75051 6.36338 8.03083 6.23681 8.25004C6.11025 8.46926 5.82994 8.54437 5.61072 8.41781L1.64143 6.12614Z"
      fill="currentColor"
    />
    <path
      d="M2.39375 17.1771C2.17454 17.3036 1.76259 17.0005 1.47365 16.5001C1.18471 15.9996 1.12819 15.4913 1.34741 15.3648L5.31669 13.0731C5.53591 12.9465 5.94785 13.2496 6.23679 13.7501C6.52573 14.2505 6.58225 14.7589 6.36304 14.8854L2.39375 17.1771Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSpinner);

export default ForwardRef;
